import { Logo, Modal, Text, Button } from '@perch-labs/shrike';
import { useCallback, useState } from 'react';
import { copyFor } from 'config';
import {
  StyledButtonMain,
  StyledFlexCrate,
  StyledListItemText,
  StyledLogo,
  StyledModalHeader,
  StyledModalHeaderBlankTitle,
  StyledTextMain,
  StyledModalHeaderBackground,
  StyledSponsoredSolarHeader,
  SponsoredSolarWelcome,
} from './modal.style';

const getCopy = copyFor('modules.welcome');
const sponsoredSolarCopy = copyFor('modules.sponsoredSolarWelcome');

const SponsoredSolarModalBody = ({ onClose }) => {
  return (
    <SponsoredSolarWelcome>
      <StyledModalHeaderBackground>
        <StyledSponsoredSolarHeader>
          <p>
            Welcome to Arcadia's{' '}
            <span style={{ fontStyle: 'italic', color: '#c3ff44' }}>
              Community Solar{' '}
            </span>
            Program
          </p>
        </StyledSponsoredSolarHeader>
      </StyledModalHeaderBackground>
      <Modal.Content>
        <Text color="accent1">{sponsoredSolarCopy('nextStepsTitle')}</Text>
        <ul aria-label="next steps list">
          {sponsoredSolarCopy('nextStepsItems').map((text, index) => (
            <li key={index}>
              <StyledFlexCrate>
                <StyledLogo>
                  <Logo
                    type="node"
                    variant="accent"
                    scale={2}
                    aria-hidden={true}
                  />
                </StyledLogo>
                <Text margin={{ left: '16px' }} color="accent1">
                  {text}
                </Text>
              </StyledFlexCrate>
            </li>
          ))}
        </ul>
        <Button
          onClick={onClose}
          backgroundColor="accent1"
          fullWidth
          margin={{ top: '16px' }}
        >
          {sponsoredSolarCopy('mainCTAText')}
        </Button>
      </Modal.Content>
    </SponsoredSolarWelcome>
  );
};

export const Welcome = () => {
  const [show, setShow] = useState(
    localStorage.getItem('showRewardsGuidelines') === 'true'
  );

  const [sponsoredSolarModal, setSponsoredSolarModal] = useState(
    localStorage.getItem('sponsoredSolar') === 'true'
  );

  const onClose = useCallback(() => {
    if (show) {
      localStorage.removeItem('showRewardsGuidelines');
      setShow(false);
    }
    if (sponsoredSolarModal) {
      localStorage.removeItem('sponsoredSolar');
      setSponsoredSolarModal(false);
    }
  }, []);

  if (!show && !sponsoredSolarModal) return null;

  return (
    <Modal aria-label="Welcome Modal" size="medium">
      {sponsoredSolarModal && <SponsoredSolarModalBody onClose={onClose} />}
      {!sponsoredSolarModal && (
        <div>
          <StyledModalHeader>
            <StyledModalHeaderBlankTitle onClose={onClose} />
          </StyledModalHeader>
          <Modal.Content>
            <StyledTextMain textStyle="heading800">
              {getCopy('title')}
            </StyledTextMain>
            <StyledTextMain textStyle="paragraph500">
              {getCopy('description')}
            </StyledTextMain>
            <StyledTextMain textStyle="heading600">
              {getCopy('nextStepsTitle')}
            </StyledTextMain>
            <ul aria-label="next steps list">
              {getCopy('nextStepsItems').map((text, index) => (
                <li key={index}>
                  <StyledFlexCrate>
                    <StyledLogo>
                      <Logo
                        type="node"
                        variant="dark"
                        scale={2}
                        aria-hidden={true}
                      />
                    </StyledLogo>
                    <StyledListItemText>{text}</StyledListItemText>
                  </StyledFlexCrate>
                </li>
              ))}
            </ul>
            <StyledButtonMain onClick={onClose}>
              {getCopy('mainCTAText')}
            </StyledButtonMain>
          </Modal.Content>
        </div>
      )}
    </Modal>
  );
};
